import { useDropzone } from 'react-dropzone'

function useFileUpload(config) {
  const fileUpload = useDropzone(config)

  return fileUpload
}

export { useFileUpload }
